export class CalRunIdModel {
    constructor(
        public id: any,
        public calRunId: any,
        public description: string,
        public active_flag: string,
        public run_status: string,
        public created_dt: Date,
        public created_by: string,
        public updated_dt: Date,
        public updated_by: string,
        public editMode: boolean,
        public comment: string,
        public startTime: any,
        public endTime: any,
        public runControlName: string,
        public runControlDesc: string,
        public userId: string,
        public uid: string,
        public comm_plan_id: number,
        public runCtrlId: number
    ) { }


}
